export default {
    namespaced: true,
    state: {
        categories: [],
    },
    getters: {
        getAll(state) {
            return state.categories;
        },
    },
    mutations: {
        setAll(state, categories) {
            Object.assign(state, {
                categories,
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const categories = await context.dispatch('api/request', {
                service: 'category',
                type: 'getAll',
            }, { root: true });

            if (categories) {
                context.commit('setAll', categories);
            }
        },
    },
};
